import React from 'react'

export default ({ className }) => (
  <svg viewBox='0 0 351 406' className={className}>
    <g fill='rgb(255,255,255)'>
      <path d='M0 406L131.56 329.87V177.63L43.85 126.88V76.12L263.12 203L219.26 228.38L175.41 203V304.5L350.82 203L0 0V152.25L87.7 203V304.5L43.85 329.87V228.38L0 203V406Z'></path>
    </g>
  </svg>
)
